<template>
  <div v-if="affectedBills.length > 0" class="selection-warning-banner">
    <div class="warning-header">
      <i class="fas fa-exclamation-triangle"></i>
      <span>
        <strong>{{ affectedBills.length }}</strong> hóa đơn có thể thất bại do thiếu cấu hình
      </span>
    </div>

    <div v-if="expanded" class="warning-bill-list">
      <div v-for="bill in affectedBills" :key="bill.billId" class="warning-bill-item">
        <span class="warning-bill-code">{{ bill.billCode }}</span>
        <span class="warning-bill-reason">{{ bill.reason }}</span>
      </div>
    </div>

    <button type="button" class="warning-toggle" @click="expanded = !expanded">
      {{ expanded ? 'Ẩn danh sách' : 'Xem danh sách' }}
      <i :class="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="ml-1"></i>
    </button>

    <small class="warning-note">
      Các hóa đơn còn lại vẫn được tạo nháp bình thường.
    </small>
  </div>
</template>

<script>
export default {
  name: 'SelectionWarningBanner',
  props: {
    /** Array of { billId, billCode, reason } */
    affectedBills: { type: Array, default: () => [] },
  },
  data() {
    return { expanded: false };
  },
};
</script>

<style lang="scss" scoped>
$draft-warning: #ffa800;
$draft-border: #ebedf3;
$draft-radius: 0.375rem;

.selection-warning-banner {
  background: #fff8dd;
  border: 1px solid darken(#fff8dd, 10%);
  border-radius: $draft-radius;
  padding: 0.6rem 0.75rem;
  margin-bottom: 0.75rem;
}

.warning-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.82rem;
  color: darken($draft-warning, 25%);

  i { flex-shrink: 0; }
}

.warning-bill-list {
  margin-top: 0.4rem;
  padding: 0.3rem 0;
  border-top: 1px solid darken(#fff8dd, 8%);
}

.warning-bill-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem 0;
  font-size: 0.78rem;
}

.warning-bill-code {
  font-weight: 600;
  color: darken($draft-warning, 25%);
  font-variant-numeric: tabular-nums;
}

.warning-bill-reason {
  color: darken($draft-warning, 15%);
}

.warning-toggle {
  display: inline-flex;
  align-items: center;
  margin-top: 0.3rem;
  padding: 0;
  border: none;
  background: none;
  color: darken($draft-warning, 25%);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;

  &:hover { color: darken($draft-warning, 35%); }
}

.warning-note {
  display: block;
  margin-top: 0.3rem;
  font-size: 0.72rem;
  color: darken($draft-warning, 15%);
}
</style>
